import React, {Component} from 'react';
import PropTypes from 'prop-types';
import logo from './logo.png';
import './style.less';

export default class Logo extends Component {
    static propTypes = {
        min: PropTypes.bool,
    };
    static defaultProps = {
        logo: logo,
        title: 'React Web',
        min: false,
    };

    render() {
        const {min, title, ...others} = this.props;     // eslint-disable-line no-unused-vars
        return (
            <div styleName="logo">
                <div styleName='bottom_title'>{  window.versions }</div>
            </div>
        );
    }
}
